module.exports = __webpack_public_path__ + "static/media/181CO156.3e48279f.jpg";